var map = {
	"./mini-bau.png": 27423,
	"./mini-ca.png": 54375,
	"./mini-cua.png": 68258,
	"./mini-ga.png": 91851,
	"./mini-nai.png": 89127,
	"./mini-tom.png": 15179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77090;